/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import mixin from '../mixin'; // 引入mixin文件
export default {
  // mixins:[mixin],
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: false
    },
    isShowMore: {
      type: Boolean,
      required: false,
      "default": false
    },
    moreText: {
      type: String,
      required: false
    },
    titleStyle: {
      type: Object,
      required: false,
      "default": function _default() {
        return {
          color: '#2E3033',
          fontSize: 18,
          fontWeight: 500
        };
      }
    },
    subTitleStyle: {
      type: Object,
      required: false,
      "default": function _default() {
        return {
          color: '#8A8F99',
          fontSize: 12,
          fontWeight: 400
        };
      }
    }
  },
  computed: {},
  data: function data() {
    return {};
  },
  methods: {
    goToMore: function goToMore() {
      this.$emit('clickMore', 'handleMore');
    }
  },
  mounted: function mounted() {}
};